export default "__VITE_ASSET__99e0c356__"